
const clearSuggestions = () => {
    return { 
        type: "CLEAR_SUGGESTIONS",
    }
}

export default clearSuggestions